module.exports = __webpack_public_path__ + "static/media/crypto.82783b4c.svg";